import { styled } from 'src/styles/stitches.config'

export const StyledContactLine = styled('div', {
    padding: '2rem 0',
    borderBottom: 'solid 2px #d5b9af',
})
